
import axios from "axios";
import { req } from "./axiosFun";

// 登录接口
export const login = params => {
  return axios({
    method: "post",
    url: "/api/login",
    headers: {
      "Content-Type": "application/json"
    },
    data: params
  }).then(res => res.data);
  // return req("post", "/api/login", params);
};
export const salespersonLogin = params => {
  return axios({
    method: "post",
    url: "/api/salesperson/login",
    headers: {
      "Content-Type": "application/json"
    },
    data: params
  }).then(res => res.data);
  // return req("post", "/api/login", params);
};
// 获取店铺信息
export const getMerchantInfo = params => {
  return req("post", "/api/getMerchantInfo", params);
};
// 获取福利接口
export const getWelfareList = params => {
  return req("post", "/api/getWelfareList", params);
};
export const manual_refund = params => {
  return req("post", "/api/manual_refund", params);
};
// 获取福利接口
export const getbusinessData = params => {
  return req("post", "/api/businessData", params);
};
// 获取收支明细
export const incomeExpenditureRecords = params => {
  return req("post", "/api/incomeExpenditureRecords", params);
};
export const getMemberActiveCount = params => {
  return req("post", "/api/getMemberActiveCount", params);
};
export const getSubscriptionNoticeCount = params => {
  return req("post", "/api/getSubscriptionNoticeCount", params);
};
export const getNewUserCount = params => {
  return req("post", "/api/getNewUserCount", params);
};
export const getTotalMemberCount = params => {
  return req("post", "/api/getTotalMemberCount", params);
};
export const getBltv = params => {
  return req("post", "/api/getBltv", params);
};
export const getJobTotal = params => {
  return req("post", "/api/getJobTotal", params);
};
export const getC_average_income = params => {
  return req("post", "/api/getC_average_income", params);
};
export const getMemberCount = params => {
  return req("post", "/api/getMemberCount", params);
};
export const getStatistics = params => {
  return req("post", "/api/getStatistics", params);
};
export const getLaborDemandRate = params => {
  return req("post", "/api/getLaborDemandRate", params);
};
// 设置福利
export const saveWelfare = params => {
  return req("post", "/api/saveWelfare", params);
};
// 获取用户
export const getAllAdmin = params => {
  return req("post", "/api/getAllAdmin", params);
};
// 初始化商家统计数据
export const initMerchantStatistics = params => {
  return req("post", "/api/init-merchant-statistics", params);
};
export const updateMerchantStatistics = params => {
  return req("post", "/api/updateMerchantStatistics", params);
};
// 设置用户
export const updateAdmin = params => {
  return req("post", "/api/updateAdmin", params);
};
// 新增用户
export const createAdmin = params => {
  return req("post", "/api/createAdmin", params);
};
// 删除
export const deleteAdmin = params => {
  return req("post", "/api/deleteAdmin", params);
};
export const changepassword = params => {
  return req("post", "/api/change/password", params);
};
// 获取职位
export const getJobType = params => {
  return req("post", "/api/getJobType", params);
};
// 设置职位
export const saveJobType = params => {
  return req("post", "/api/saveJobType", params);
};
// 设置职位
export const deleteJobType = params => {
  return req("post", "/api/deleteJobType", params);
};
// 获取审核列表
export const getAuditList = params => {
  return req("post", "/api/getAuditList", params);
};
export const setMerchantServiceFee = params => {
  return req("post", "/api/setMerchantServiceFee", params);
};
// 设置审核
export const setAuditStatus = params => {
  return req("post", "/api/setAuditStatus", params);
};
// 审核详情
export const getAuditDetail = params => {
  return req("post", "/api/getAuditDetail", params);
};
// 个人菜单
export const getMenu = params => {
  return req("post", "/api/getMenu", params);
};
// 所有菜单
export const getAllMenu = params => {
  return req("post", "/api/getAllMenu", params);
};
// 保存菜单
export const saveMenu = params => {
  return req("post", "/api/saveMenu", params);
};
// 编辑菜单
export const updateMenu = params => {
  return req("post", "/api/updateMenu", params);
};
// 删除菜单
export const deleteMenu = params => {
  return req("post", "/api/deleteMenu", params);
};
// 个人信息
export const getInfo = params => {
  return req("post", "/api/getInfo", params);
};
// 业务员个人信息
export const getSalespersonInfo = params => {
  return req("post", "/api/getSalespersonInfo", params);
};
// 角色列表
export const getRoleList = params => {
  return req("post", "/api/getRoleList", params);
};
// 设置权限
export const setRolePermision = params => {
  return req("post", "/api/setRolePermision", params);
};
// 数据看板
export const dataBoard = params => {
  return req("post", "/api/dataBoard", params);
};
export const getAverageTime = params => {
  return req("post", "/api/getAverageTime", params);
};
// 添加兼职
export const upJobInfo = params => {
  return req("post", "/api/upJobInfo", params);
};
// 添加兼职
export const getLocations = params => {
  return req("post", "/api/getLocations", params);
};
// 数据看板
// // 上传图片
export const upload = params => {
  return req("post", "/file/upload/img", params);
};
// 获取所有会员
export const getAllMember = params => {
  return req("post", "/api/getAllMember", params);
};
// 获取所有会员
export const auditDrawRecords = params => {
  return req("post", "/api/auditDrawRecords", params);
};
// 获取所有会员
export const confirmDraw = params => {
  return req("post", "/api/confirmDraw", params);
};
export const cashconfirm = params => {
  return req("post", "/api/cash/confirm", params);
};
// 获取所有会员
export const rejectDrawApplication = params => {
  return req("post", "/api/rejectDrawApplication", params);
};
export const queryTransferRecords = params => {
  return req("post", "/api/queryTransferRecords", params);
};
export const queryTransferStatus = params => {
  return req("post", "/api/cash/queryTransfer", params);
};
export const getMemberJobs = params => {
  return req("post", "/api/getMemberJobs", params);
};
export const getMemberJobDetail = params => {
  return req("post", "/api/getMemberJobDetail", params);
};
export const setMemberStatus = params => {
  return req("post", "/api/setMemberStatus", params);
};
export const delMemberStatus = params => {
  return req("post", "/api/member/delete", params);
};
// 获取城市工资
export const getWagesList = params => {
  return req("post", "/api/getWagesList", params);
};
export const setWages = params => {
  return req("post", "/api/setWages", params);
};
// 获取招聘列表
export const getAllJobList = params => {
  return req("post", "/api/getAllJobList", params);
};
export const getAllbill = params => {
  return req("post", "/api/getAllbill", params);
};
export const getJobById = params => {
  return req("post", "/api/getJobAndSubInfoById", params);
};
export const getApplyDetail = params => {
  return req("post", "/api/getApplyDetail", params);
};
export const setApplyStatus = params => {
  return req("post", "/api/setApplyStatus", params);
};
export const getMerchantData = params => {
  return req("post", "/api/getMerchantData", params);
};
export const getCityWage = params => {
  return req("post", "/api/getCityWage", params);
};
export const getUnCompleteJob = params => {
  return req("post", "/api/getUnCompleteJob", params);
};
export const deleteMerchant = params => {
  return req("post", "/api/deleteMerchant", params);
};
export const deleteApply = params => {
  return req("post", "/api/deleteApply", params);
};
export const deleteJob = params => {
  return req("post", "/api/deleteJob", params);
};
export const refund = params => {
  return req("post", "/api/refund", params);
};
export const getJobDetails = params => {
  return req("post", "/api/getJobDetails", params);
};
export const deleteJobDetail = params => {
  return req("post", "/api/deleteJobDetail", params);
};
export const getJobDetail = params => {
  return req("post", "/api/getJobDetail", params);
};
export const getfeedbackreplyquery = params => {
  return req("post", "/api/feedback/query", params);
};
export const getfeedreplyquery = params => {
  return req("post", "/api/feed/query", params);
};
export const deletefeedbackreplyquery = params => {
  return req("post", "/api/feedback/delete", params);
};
export const getfeedbackreplyreply = params => {
  return req("post", "/api/feedback/reply", params);
};
export const getfeedbackreplyreplys = params => {
  return req("post", "/api/feed/reply/create", params);
};
export const getreplyquery = params => {
  return req("post", "/api/feedback/reply/query", params);
};
export const getreplyquerys = params => {
  return req("post", "/api/feed/reply/query", params);
};
export const postreportsearch = params => {
  return req("post", "/api/report/search", params);
};
export const setMerchantPayFields = params => {
  return req("post", "/api/setMerchantPayFields", params);
};
export const getMerchantApplyList = params => {
  return req("post", "/api/getMerchantApplyList", params);
};
export const generateBillPdf = params => {
  return req("post", "/api/generateAllMerchantsBillPdf", params);
};
export const getBillPdfList = params => {
  return req("post", "/api/getBillPdfList", params);
};
export const downloadBillPdfs = params => {
  return req("post", "/api/downloadBillPdfs", params);
};
export const getBillPdfDetail = params => {
  return req("post", "/api/getBillPdfDetail", params);
};
export const queryLaborContract = params => {
  return req("post", "/api/queryLaborContract", params);
};
// 业务员相关接口
export const updateSalespersonStatistics = params => {
  return req("post", "/api/updateSalespersonStatistics", params);
};
export const getSalespersonList = params => {
  return req("post", "/api/getSalespersonList", params);
};
export const getSalespersonDetail = params => {
  return req("post", "/api/getSalespersonDetail", params);
};
export const getMerchantStatisticsByUserId = params => {
  return req("post", "/api/getMerchantStatisticsByUserId", params);
};
export const addSalesperson = params => {
  return req("post", "/api/addSalesperson", params);
};
export const updateSalesperson = params => {
  return req("post", "/api/updateSalesperson", params);
};
export const deleteSalesperson = params => {
  return req("post", "/api/deleteSalesperson", params);
};
export const postreportexport = params => {
  return req(
    "get",
    `/api/report/export?merchantId=${params.merchantId}&current=1&size=9999999&startTime=${params.startTime}&endTime=${params.endTime}`
  );
};
// export const upload = params => {
//   return axios({
//     method: "post",
//     url: "/file/upload/img",
//     headers: {
//       "Content-Type": "application/json",
//       token: localStorage.getItem("logintoken")
//     },
//     data: params
//   }).then(res => res.data);
//   // return req("post", "/api/login", params);
// };

// // 用户管理-刷新缓存
// export const userFlashCache = params => {
//   return req("get", "/api/User/flashCache/" + params, {});
// };

// 批量查询多个商家的兼职申请列表
export const getMerchantsBatchApplyList = params => {
  return req("post", "/api/getMerchantsBatchApplyList", params);
};

// ======== 通知管理相关接口 ========
// 获取通知列表
export const getNotificationList = params => {
  return req("post", "/api/notification/getList", params);
};

// 获取未读通知数量
export const getUnreadNotificationCount = params => {
  return req("post", "/api/notification/getUnreadCount", params);
};

// 标记通知为已读
export const markNotificationAsRead = params => {
  return req("post", "/api/notification/markAsRead", params);
};
// 处理通知
export const disposeBacklog = params => {
  return req("post", "/api/notification/disposeBacklog", params);
};
// 批量标记所有通知为已读
export const markAllNotificationsAsRead = params => {
  return req("post", "/api/notification/markAllAsRead", params);
};

// 获取通知详情
export const getNotificationDetail = params => {
  return req("post", "/api/notification/getDetail", params);
};
// 托管审核
export const trusteeshipAudit = params => {
  return req("post", "/api/trusteeshipAudit", params);
};
export const applyChange = params => {
  return req("post", "/api/applyChange", params);
};


export const sendMessage = params => {
  return req("post", "/api/sendMsg", params);
};


// WEBPACK FOOTER //
// ./src/api/userMG.js